import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Configuration } from '@shared/models/configuration';
import { FieldDefinition } from '@shared/models/field-definition';
import { SnackBarService } from '@core/services/snack-bar.service';
import { ISmartGridDataState } from '@shared/store/reducers/smart-grid.reducers';
import { ToggleStateCommand } from '../../../commands/notifications.commands';
import { ToggleStateAction } from '../../../store/actions/notifications.actions';

@Component({
    standalone: false,
    selector: 'lib-notification-state-cell-viewer',
  templateUrl: './notification-state-cell-viewer.component.html',
  styleUrls: ['./notification-state-cell-viewer.component.scss']
})
export class NotificationStateCellViewerComponent implements OnInit {

  item: any;
  fieldDefinition: FieldDefinition;
  sourceType: string;

  constructor(private smartGridStore: Store<ISmartGridDataState>, private snackBarService: SnackBarService) { }

  ngOnInit() {
  }

  isDisabled(): boolean {
    return Configuration.ApplicationId !== this.item.cells.Application.value;
  }

  toggleStatus(isActive: boolean) {
    if (this.isDisabled()) {
      this.snackBarService.showError('You can not toggle state of notification of other applications');
      return;
    }
    const command = new ToggleStateCommand(this.item.id, isActive);
    this.smartGridStore.dispatch(new ToggleStateAction(command, this.sourceType));
  }

}
